/* wc-color-swatches — standalone COLOUR WAY swatches, HEllO EDC, 22 Sep 2026 (v2)

   Paints each swatch chip from window.colorSwatchMap (the same map the
   theme's own button-colour-sync script already builds from the variant
   swatch metaobject), and drives the ORIGINAL, now-hidden colour radio
   inputs by calling .click() on them — never by inventing a parallel
   selection mechanism. A native .click() on a form control fires a real,
   trusted click/change event even while its ancestor fieldset is
   display:none, so every script already listening for a colour change
   (variant recalculation, the mobile-variant-btn state tracker, the guided
   Add to Cart button) reacts exactly as if the shopper had tapped the
   original control directly.

   v2 fix: Dawn's <variant-selects> custom element replaces its entire DOM
   subtree (including the nested .wc-swatches host) on every variant change,
   so v1's boot()-time cached `host` reference went stale after the very
   first click — the swatch chips repainted onto a detached node and the
   click listener stopped working. Every function below now re-queries
   `[data-wc-swatches]` fresh, and the click listener is delegated on
   `document` instead of bound to a single captured host, so it keeps
   working across any number of DOM replacements. */

(function () {
  'use strict';

  if (window.__wcColorSwatches) return;
  window.__wcColorSwatches = true;

  function getHost() {
    return document.querySelector('[data-wc-swatches]');
  }

  function optionScope(host) {
    var idx = host.getAttribute('data-option-index');
    return document.querySelector('variant-selects fieldset[data-option-index="' + idx + '"]');
  }

  function paintChips(host) {
    if (!host) return;
    var map = window.colorSwatchMap || {};
    host.querySelectorAll('.wc-swatches__item').forEach(function (item) {
      var value = item.getAttribute('data-wc-swatch-value');
      var chip = item.querySelector('[data-wc-swatch-chip]');
      if (!chip) return;
      var color = map[value];
      chip.style.backgroundImage = '';
      chip.style.backgroundColor = '';
      if (!color) return;
      if (color.indexOf('url(') === 0) {
        chip.style.backgroundImage = color;
      } else {
        chip.style.backgroundColor = color;
      }
    });
  }

  function currentValue(host) {
    var scope = optionScope(host);
    if (!scope) return null;
    var checked = scope.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    var sel = scope.querySelector('select');
    if (sel) return sel.value;
    return null;
  }

  function paintState(host, value) {
    if (!host) return;
    host.querySelectorAll('.wc-swatches__item').forEach(function (item) {
      var on = item.getAttribute('data-wc-swatch-value') === value;
      item.classList.toggle('is-selected', on);
      item.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var name = host.querySelector('[data-wc-swatch-name]');
    if (name && value) name.textContent = value;
  }

  function selectValue(host, value) {
    var scope = optionScope(host);
    if (!scope) return;

    var radios = scope.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) {
        if (!radios[i].checked) radios[i].click();
        return;
      }
    }

    var sel = scope.querySelector('select');
    if (sel) {
      var options = sel.querySelectorAll('option');
      for (var j = 0; j < options.length; j++) {
        if (options[j].value === value) {
          sel.value = value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }
  }

  function boot() {
    var host = getHost();
    if (!host) return;

    paintChips(host);

    /* Delegated on document rather than bound to a captured host element,
       so a click still resolves correctly after <variant-selects> has
       thrown away and rebuilt the swatches markup any number of times. */
    document.addEventListener('click', function (e) {
      var item = e.target.closest && e.target.closest('.wc-swatches__item');
      if (!item) return;
      var liveHost = item.closest('[data-wc-swatches]');
      if (!liveHost) return;
      var value = item.getAttribute('data-wc-swatch-value');
      if (!value) return;
      selectValue(liveHost, value);
      paintState(liveHost, value);
    });

    /* Keep the swatches themselves in sync if anything else on the page
       ever changes the colour (e.g. a "shop the look" link that preselects
       a variant via URL), not just the other way around. Re-query the host
       fresh — the one captured at boot() may already be gone by the time
       this fires. */
    document.addEventListener('change', function (e) {
      if (!e.target.closest || !e.target.closest('variant-selects')) return;
      var liveHost = getHost();
      if (!liveHost) return;
      var idx = liveHost.getAttribute('data-option-index');
      if (!e.target.closest('[data-option-index="' + idx + '"]')) return;
      paintState(liveHost, currentValue(liveHost));
    });

    /* The theme rebuilds the whole variant-selects subtree on some variant
       changes, so the swatch chips are repainted whenever colorSwatchMap
       could plausibly have gained new entries or the DOM was replaced.
       Re-query the host fresh each time rather than reusing the one from
       boot(), since that node may have already been detached. */
    var productInfo = document.querySelector('product-info') || document.querySelector('.product__info-wrapper');
    if (productInfo && window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        if (pending) return;
        pending = setTimeout(function () {
          pending = null;
          paintChips(getHost());
        }, 150);
      }).observe(productInfo, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
